/* eslint-disable func-names */
import { FETCH_SMS_SAFE_PROMOT, GET_EVENTS_MEETINGS, FETCH_DEFAULT_TILES } from './types';

const INITIAL_STATE = {
  action: { loading: false, success: false, error: false },
  customTiles: [],
  defaultTiles: [],
  smsSafetyPromMeetings: []
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_SMS_SAFE_PROMOT.pending:
      return {
        ...state,
        action: { loading: true, success: false, error: false }
      };
    case FETCH_SMS_SAFE_PROMOT.success:
      return {
        ...state,
        customTiles: action.payload,
        action: { loading: false, success: true, error: false }
      };
    case FETCH_SMS_SAFE_PROMOT.error:
      return {
        ...state,
        action: { loading: false, success: false, error: true }
      };
    case FETCH_DEFAULT_TILES.pending:
      return {
        ...state,
        action: { loading: true, success: false, error: false }
      };
    case FETCH_DEFAULT_TILES.success:
      return {
        ...state,
        action: { loading: false, success: true, error: false },
        defaultTiles: action.payload
      };
    case FETCH_DEFAULT_TILES.error:
      return {
        ...state,
        action: { loading: false, success: false, error: true }
      };
    case GET_EVENTS_MEETINGS.success:
      return {
        ...state,
        smsSafetyPromMeetings: action.payload
      };
    default:
      return state;
  }
}
